import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';

import {
    AppBar,
    Button,
    ThemeProvider,
    Toolbar,
    Typography
} from "@mui/material";

import { Global } from '@emotion/react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { AddWidgets, Drawer, Form, ScaleAndDrag, darkTheme } from "@/components/Editor";

import background from "@/assets/background.svg";
import { Frame } from "@/components/frames";
import './Editor.css';
import {sendOverlayData, fetchOverlayData} from "@/utils/backendUtils";
import {useEffect, useRef, useState} from "react";
import cloneDeep from "lodash.clonedeep";
import eventBus from "@/utils/globalPubSub";

const BoardBox = styled(Box)(({ theme }) => ({
    flex: 1,
    backgroundImage: `url(${background})`,
    backgroundPosition: '0 0',
    backgroundRepeat: 'round',
    backgroundSize: '10px',
    backgroundColor: 'black',
    position: 'relative'
}));

const WIDGET_CONFIG = {
    social: [
        {
            type: 'radio',
            name: 'widget',
            label: 'Select Widget type',
            value: 'neo'
        },
        {
            type: 'color',
            name: 'color',
            label: 'Select Widget color',
            value: '#144F32'
        },
        {
            type: 'input',
            name: 'instagram',
            label: 'Instagram',
            value: ''
        },
        {
            type: 'input',
            name: 'youtube',
            label: 'Youtube',
            value: ''
        },
        {
            type: 'input',
            name: 'twitter',
            label: 'Twitter',
            value: ''
        },
        {
            type: 'input',
            name: 'twitch',
            label: 'Twitch',
            value: ''
        },
        {
            type: 'input',
            name: 'facebook',
            label: 'Facebook',
            value: ''
        }
    ],
    donation: [
        {
            type: 'radio',
            name: 'widget',
            label: 'Select Widget type',
            value: 'neo'
        },
        {
            type: 'color',
            name: 'color',
            label: 'Select Widget color',
            value: '#144F32'
        },
        {
            type: 'input',
            name: 'phone',
            label: 'Phone number',
            value: ''
        }
    ],
    iframe: [
        {
            type: 'input',
            name: 'iframe',
            label: 'URL',
            value: ''
        }
    ],
    image: [        
        {
            type: 'input',
            name: 'image',
            label: 'Upload Image',
            value: ''
        },        
    ],
}
const DRAWER = 50;
// const MAIN_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiI2IiwiYXV0aCI6dHJ1ZSwiaWF0IjoxNjQ5Nzc4NjYxLCJleHAiOjE2NTIzNzA2NjF9.I4f1KtFOu41gU7EcWUgUTTjCwFp2R-X2MwurwIutyi8'
// const MAIN_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOjMwMDgwLCJhdXRoIjp0cnVlLCJpYXQiOjE2NTA1NTg4NzF9.t3QH8bmdwnMJMexOKFs71SD9oMoAOWS_fzJEpBsv1rA'
const MAIN_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiI2IiwiYXV0aCI6dHJ1ZSwiaWF0IjoxNjQ5Nzc4NjYxLCJleHAiOjE2NTIzNzA2NjF9.I4f1KtFOu41gU7EcWUgUTTjCwFp2R-X2MwurwIutyi8'

export default function Editor() {
    const [widgets, setWidgets] = React.useState([]);
    const [selectedWidget, setSelectedWidget] = React.useState(null);
    const [token, setToken] = useState(window.token);
    const [imageUrl, setImageUrl] = useState(false);

    useEffect(async () => {
        eventBus.on("callbackNativeSupportReady", () => {
            window?.getUserInfo?.();
        });
        eventBus.on("callbackUserInfo", (userInfo) => {
            setToken(userInfo.token)
            window?.setPreference?.("stream_overlay_url", "https://glip.gg/overlay/")
        });
        eventBus.on("callbackCurrentOrientation", (orientationInfo) => {
            // alert(window.orientationInfo)
            // alert(JSON.stringify(orientationInfo))
        });

        return () => {
            eventBus.remove("callbackNativeSupportReady");
            eventBus.remove("callbackUserInfo");
            eventBus.remove("callbackCurrentOrientation");
        }
    }, [])

    useEffect(async () => {
        if (token) {
            try {
                const result = await fetchOverlayData(token);
                if (result.success) {
                    console.log('widgets count', result.data?.data ? JSON.parse(result.data?.data).length : 0)
                    setWidgets(result.data?.data ? JSON.parse(result.data?.data) : [])
                } else {
                    // alert(result.message)
                }
            } catch (e) {
                // alert(e);
                console.log('error', e)
            }

        }
    }, [token])

    const addWidget = (type) => {
        const newIdx = widgets.at(-1) ? widgets.at(-1).id + 1 : 0;

        setWidgets([...widgets, {
            id: newIdx,
            type,
            css: {
                scale: type === 'iframe' ? 0.15 : 1
            },
            form: [...WIDGET_CONFIG[type]]
        }])
    }

    const handleRemove = (selected) => {
        const index = widgets.findIndex((it) => it.id === selected.id);
        const newArr = [...widgets];
        newArr.splice(index, 1)

        setSelectedWidget(null);
        setWidgets(newArr);
    }

    const onSubmit = (data) => {
        const index = widgets.findIndex((it) => it.id === data.id);
        const newArr = [...widgets];
        // data.css.scale = 1; // Why this?
        newArr.splice(index, 1, data)

        setWidgets(newArr);
        setSelectedWidget(null);
    };

    const handleSnDStop = (data) => {
        const widget = cloneDeep(selectedWidget);
        widget.css = {
            ...widget.css,
            ...data
        };
        const index = widgets.findIndex((it) => it.id === widget.id);
        const newArr = [...widgets];
        newArr.splice(index, 1, widget)

        setSelectedWidget(widget);
        setWidgets(newArr);
    }

    const handleSaveButton = async () => {
        await sendOverlayData(widgets, token);
        window?.showToastMessage?.("Overlay setup complete")
        window?.closeActivity?.()
    }

    const renderWidgetBox = (it) => {
        let image_url = false;
        if(it.type === 'image' && it.form[0]?.value != '') {
            console.log('Image widget processing:', {
                type: typeof it.form[0]?.value,
                value: it.form[0]?.value,
                isFile: it.form[0]?.value instanceof File,
                isBlob: it.form[0]?.value instanceof Blob,
                constructor: it.form[0]?.value?.constructor?.name
            });
            
            var reader = new FileReader();
            reader.onloadend = function() {
                image_url = reader.result;
                setImageUrl(image_url);
            }
            // check if it.form[0]?.value is string or not
            if(typeof it.form[0]?.value === 'string') {
                console.log('Processing as string:', it.form[0]?.value);
                image_url = it.form[0]?.value;
                if(!imageUrl)
                    setImageUrl(image_url);
            } else if (it.form[0]?.value instanceof File || it.form[0]?.value instanceof Blob) {
                console.log('Processing as File/Blob with FileReader');
                reader.readAsDataURL(it.form[0]?.value);
            } else if (it.form[0]?.value instanceof FileList && it.form[0]?.value.length > 0) {
                console.log('Processing as FileList with FileReader');
                reader.readAsDataURL(it.form[0]?.value[0]);
            } else {
                console.log('Unknown type - not processing with FileReader');
            }            
        }    
        if (it.id === selectedWidget?.id) {
            
            return (
                <ScaleAndDrag
                    key={`widget-${it.id}`}
                    // selected={it.id === selectedWidget?.id}
                    // onSelect={() => setSelectedWidget(it)}
                    onDragStop={handleSnDStop}
                    onResizeStop={handleSnDStop}
                    onRemove={() => handleRemove(it)}
                    config={it}
                >
                    {(it.type !== 'iframe' && it.type !== 'image') && <Frame config={it}/>}
                    {it.type === 'iframe' && <Box style={{ height: '100%', cursor:'pointer', position: 'relative'}}>
                        <iframe
                            style={{
                                border: '0',
                                margin: '0',
                                overflow: 'hidden',
                                padding: 0,
                                width: '1920px',
                                height: '1080px'
                            }}
                            src={it.form[0]?.value ?? ''}
                        />
                        <div style={{
                            border: '1px solid grey',
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            top: 0
                        }}/>
                    </Box>}
                    {it.type === 'image' && <Box style={{ height: '100%', cursor:'pointer', position: 'relative'}}>
                        <img
                            style={{
                                border: '0',
                                margin: '0',
                                overflow: 'hidden',
                                padding: 0,
                                width: it.css.width ? it.css.width : '192px',
                                height: it.css.height ? it.css.height :'108px'
                            }}
                            src={imageUrl}
                        />
                        <div style={{
                            border: '1px solid #ccc',
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            top: 0
                        }}/>
                    </Box>}
                </ScaleAndDrag>
            )
        }
        else {            
            return (
                <Box
                    key={`widget-${it.id}`}
                    onClick={(e) => {
                        e.stopPropagation();
                        setSelectedWidget(it)
                    }}
                    position={'absolute'}
                    left={it?.css?.x ? it?.css?.x : 0}
                    top={it?.css?.y ? it?.css?.y : 0}
                    sx={{
                        // transform: `scale(${it?.css?.scale ? it?.css?.scale : 1})`,
                        width: it?.css?.width ? it?.css?.width : 'auto',
                        height: it?.css?.height ? it?.css?.height : 'auto',
                        // transformOrigin: '0 0'
                    }}
                >
                    {(it.type !== 'iframe' && it.type !== 'image') && <Frame config={it}/>}
                    {it.type === 'iframe' && <Box style={{ height: '100%', cursor:'pointer', position: 'relative'}}>
                        <iframe
                            style={{
                                border: '0',
                                margin: '0',
                                overflow: 'hidden',
                                padding: 0,
                                width: '1920px',
                                height: '1080px'
                            }}
                            src={it.form[0]?.value ?? ''}
                        />
                        <div onClick={(e) => {
                            e.stopPropagation();
                            setSelectedWidget(it)
                        }} style={{
                            border: '1px solid grey',
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            top: 0
                        }}/>
                    </Box>}
                    {it.type === 'image' && <Box style={{ height: '100%', cursor:'pointer', position: 'relative'}}>
                        {it.form[0]?.value != '' && <img
                            style={{
                                border: '0',
                                margin: '0',
                                overflow: 'hidden',
                                padding: 0,
                                width: it.css.width? it.css.width:'192px',
                                height: it.css.height ? it.css.height :'108px'
                            }}
                            src={imageUrl ?? 'data:'}
                        />}
                        {!it.form[0]?.value != '' && <div style={{
                            border: '0',
                            margin: '0',
                            overflow: 'hidden',
                            padding: 0,
                            width: '192px',
                            height: '108px',
                            backgroundColor: 'grey',
                            color: 'white',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>Upload Image</div>}
                        
                        <div onClick={(e) => {
                            e.stopPropagation();
                            setSelectedWidget(it)
                        }} style={{
                            border: '1px solid #ccc',
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            top: 0
                        }}/>
                    </Box>}
                </Box>
            )
        }
    }

    return (
        <React.Fragment>
            <ThemeProvider theme={darkTheme}>
                <Box display={"flex"} flexDirection={"column"} height={"100%"}>
                    <CssBaseline />

                    <Global
                        styles={{
                            '.MuiDrawer-root > .MuiPaper-root': {
                                height: `calc(80% - ${DRAWER}px)`,
                                overflow: 'visible',
                            },
                        }}
                    />

                    <AppBar position={"relative"}>
                        <Toolbar>
                            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                                Overlay
                            </Typography>
                            <Button variant="contained" color="secondary" onClick={handleSaveButton}>Save</Button>
                        </Toolbar>
                    </AppBar>

                    <AddWidgets onAddWidget={addWidget}/>

                    <BoardBox onClick={() => {setSelectedWidget(null)}}>
                        {
                            widgets.map((it) => renderWidgetBox(it))
                        }
                    </BoardBox>

                    {selectedWidget && <Drawer>
                        <Form config={selectedWidget} onSubmit={onSubmit}/>
                    </Drawer>}
                </Box>
            </ThemeProvider>
        </React.Fragment>
    );
}
